import Collapsible from 'react-collapsible';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Col, Form, Input, Row } from 'antd';
import { ProfileModal } from '@/components/modals';
import { AppButton, Flex, IcArrow } from '@/components';
import { useChangeCVV2, useChangePassword, useModal } from '@/hooks';
import formErrors from '@/utils/formErrors';
import { useUniversityContext, useUserContext } from '@/context';
import { useTranslation } from 'react-i18next';

const BUTTON_CLASSES = 'flex w-full justify-center items-center h-[38px]';

const ProfilePageMobile = () => {

  const modal = useModal();
  const [t] = useTranslation(['common']);
  const { profile, profileImage } = useUserContext();
  const { university } = useUniversityContext();
  const scope = new URLSearchParams(useLocation().search).get('scope')?.toLowerCase();

  const [passSubmit, setPassSubmit] = useState(false);
  const [cvv2Submit, setCvv2Submit] = useState(false);

  const { formik: cvv2Formik, loading: cvv2Loading } = useChangeCVV2();
  const { formik: passFormik, loading: passLoading } = useChangePassword();

  return (
    <Flex className="app-profile-page app-profile-mobile" direction="column">
      <ProfileModal {...modal} />
      <Flex
        direction="row"
        onClick={modal.show}
        className="app-profile-card">
        <Flex direction="column">
          <span className="profile-name">{profile.firstName} {profile.lastName}</span>
          <span className="text-[#2F0B5F]">{university?.universityLabel}</span>
          <span className="text-[#2F0B5F]">{profile?.student?.studyMajor?.name}</span>
          <span className="text-white">{profile?.student?.studentNumber}</span>
        </Flex>
        <Flex className="!ms-auto" justify="center" align="center">
          <img className="profile-image max-h-[100px]" src={profileImage} />
          {/* <img className="max-h-[100px]" src={ } alt="" /> */}
        </Flex>
      </Flex>
      <Flex className="app-profile-collapsible-list" direction="column">
        <Collapsible
          open={scope === 'password'}
          classParentString="collapsible-item"
          transitionTime={300}
          trigger={(
            <div className="flex flex-row items-center w-full">
              <b>{t('common:labels.password')}</b>
              <span className="!ms-auto">
                <IcArrow className="collapsible-arrow" />
              </span>
            </div>
          )}
        >
          <Flex className="pt-3" direction="column" gap="0.5rem">
            <Row className="w-full" gutter={[0, 16]}>
              <Col span={24}>
                <Form.Item {...formErrors(passFormik.errors.currentPassword, passSubmit)}>
                  <Input.Password
                    name="currentPassword"
                    placeholder={t('common:labels.current-password')}
                    onChange={passFormik.handleChange}
                    value={passFormik.values.currentPassword}
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item {...formErrors(passFormik.errors.newPassword, passSubmit)}>
                  <Input.Password
                    name="newPassword"
                    placeholder={t('common:labels.new-password')}
                    onChange={passFormik.handleChange}
                    value={passFormik.values.newPassword}
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item {...formErrors(passFormik.errors.newPasswordConfirm, passSubmit)}>
                  <Input.Password
                    name="newPasswordConfirm"
                    placeholder={t('common:labels.confirm-new-password')}
                    onChange={passFormik.handleChange}
                    value={passFormik.values.newPasswordConfirm}
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <AppButton
                  appVariant="nurture"
                  loading={passLoading}
                  className={BUTTON_CLASSES}
                  onClick={() => {
                    setPassSubmit(true); passFormik.submitForm();
                  }}>
                  {t('common:labels.update')}
                </AppButton>
              </Col>
            </Row>
          </Flex>
        </Collapsible>
        <Collapsible
          open={scope === 'cvv2'}
          classParentString="collapsible-item"
          transitionTime={300}
          trigger={(
            <div className="flex flex-row items-center w-full">
              <b>{t('common:labels.cvv2')}</b>
              <span className="!ms-auto">
                <IcArrow className="collapsible-arrow" />
              </span>
            </div>
          )}
        >
          <Flex className="pt-3" direction="column" gap="0.5rem">
            <Row className="w-full" gutter={[0, 16]}>
              <Col span={24}>
                <Form.Item {...formErrors(cvv2Formik.errors.newCvv2, cvv2Submit)}>
                  <Input.Password
                    name="newCvv2"
                    inputMode="numeric"
                    placeholder={t('common:labels.new-password')}
                    onChange={cvv2Formik.handleChange}
                    value={cvv2Formik.values.newCvv2}
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item {...formErrors(cvv2Formik.errors.confirmNewCvv2, cvv2Submit)}>
                  <Input.Password
                    name="confirmNewCvv2"
                    inputMode="numeric"
                    placeholder={t('common:labels.confirm-new-password')}
                    onChange={cvv2Formik.handleChange}
                    value={cvv2Formik.values.confirmNewCvv2}
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <AppButton
                  appVariant="nurture"
                  loading={cvv2Loading}
                  className={BUTTON_CLASSES}
                  onClick={() => {
                    setCvv2Submit(true);
                    cvv2Formik.submitForm();
                  }}>
                  {t('common:labels.update')}
                </AppButton>
              </Col>
            </Row>
          </Flex>
        </Collapsible>

        {/* {university?.samad?.faceEnrollment &&
          <Collapsible
            open={scope === 'face-enrollment'}
            classParentString="collapsible-item"
            transitionTime={300}
            trigger={(
              <div className="flex flex-row items-center w-full">
                <b>{t('common:labels.authentication')}</b>
                <span className="!ms-auto">
                  <IcArrow className="collapsible-arrow" />
                </span>
              </div>
            )}>
            <Flex className="pt-3" direction="column" gap="0.5rem">
              <FaceEnrollment />
            </Flex>
          </Collapsible>
        } */}
      </Flex>
    </Flex>
  );
};

export default ProfilePageMobile;
